import { faBed, faBroom, faCalendarCheck, faCalendarDay, faChartPie } from "@fortawesome/free-solid-svg-icons";
import TabNav from "components/common/tabs/TabNav";
import TabNavLink from "components/common/tabs/TabNavLink";
import { AppRoutes } from "config/router";
import { Outlet } from "react-router-dom";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const AccommodationOverviewPage = () => {
    const context = useAppContext();

    return (
        <div className="accommodation-page app-tabs">
            <TabNav>
                <TabNavLink
                    to={AppRoutes.ACCOMMODATION_OVERVIEW_HOME}
                    text="pages.accommodation.booking.list"
                    icon={faBed}
                    hidden={!context.userHasRole(Roles.ACCOMMODATION_BOOKINGS_READ)}
                />
                <TabNavLink
                    to={AppRoutes.ACCOMMODATION_OVERVIEW_EVENT}
                    text="pages.accommodation.event.list"
                    icon={faCalendarDay}
                    hidden={!context.userHasRole(Roles.ACCOMMODATION_BOOKINGS_READ)}
                />
                <TabNavLink
                    to={AppRoutes.ACCOMMODATION_OVERVIEW_AVAILABILITY}
                    text="pages.accommodation.availability"
                    icon={faCalendarCheck}
                    hidden={!context.userHasRole(Roles.ACCOMMODATION_WORK_READ)}
                />
                <TabNavLink
                    to={AppRoutes.ACCOMMODATION_OVERVIEW_MAINTENANCE}
                    text="pages.accommodation.work.maintenance.list"
                    icon={faBroom}
                    hidden={!context.userHasRole(Roles.ACCOMMODATION_WORK_READ)}
                />
                <TabNavLink
                    to={AppRoutes.ACCOMMODATION_OVERVIEW_OVERVIEW}
                    text="pages.overview"
                    icon={faChartPie}
                    hidden={!context.userHasRole(Roles.ACCOMMODATION_BOOKINGS_READ)}
                />
            </TabNav>
            <Outlet />
        </div>
    );
};

export default AccommodationOverviewPage;
